import { errorCircleIcon } from '@/uiIcons/errorCircleIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { icon } from '@/uiPrimitives/media/icon';
import { textBlock } from '@/uiPrimitives/typography/text';
import { ReactNode } from 'react';

export const FieldIssue = ({
	id,
	children,
	className,
	hiddenClassName,
}: {
	id: string;
	children: ReactNode;
	className?: string;
	hiddenClassName: string | false | undefined;
}) => {
	return (
		<div id={id} role="alert" className={className}>
			<div
				className={classes(
					shelf({
						gap: '1 | h3',
						alignItems: 'start',
					}),
					hiddenClassName,
				)}
			>
				<span className={classes(occupy({ blockSize: '0 | p' }))}>
					<i
						className={classes(
							icon({
								icon: errorCircleIcon,
								display: 'inline-block',
								blockSize: 'auto',
								inlineSize: '3 | h1',
								fill: 'positiveRed',
							}),
						)}
					/>
				</span>
				<div className={classes(textBlock({ color: 'positiveRed' }))}>
					{children}
				</div>
			</div>
		</div>
	);
};
